import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitCommit } from '@/services/git/api';
import type { GitCommitDetail } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitCommit(
  repoFullName: string | null | undefined,
  sha: string | null | undefined,
): UseQueryResult<GitCommitDetail | null, Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitCommit', orgId, repoFullName, sha],
    queryFn: () => fetchGitCommit(orgId!, repoFullName!, sha!),
    enabled: !!token && !!orgId && !!repoFullName && !!sha,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    meta: { silent: true },
  });
}
